<div class="filter-tray">
    <div class="tray-items" [formGroup]="byDepartmentForm">
        <div formArrayName="departments">
            <div class="tray-row" *ngFor="let departmentCtrl of departments.controls; let i = index">
                <single-choice
                    [formControl]="departmentCtrl"
                    (click)="setEditingIndex(i)"
                    [completedUrl]="completionUrl"
                    [topic]="'departments'"
                    [editMode]="true"
                    [ticketId]="fakeId"
                    [icon]="'apartment'"
                    (choiceEvent)="relaySingleChoice($event)"
                    [labelOnDemand]="departmentLabelerByService"
                    [choiceObserver]="departmentObserver">
                </single-choice>
                <button type="button" class="row-remove" (click)="removeField(i)" [disabled]="departments.length <= 1">
                    <i class="material-icons-outlined">close</i>
                </button>
            </div>
        </div>
    </div>
    <div class="tray-footer">
        <button type="button" class="add-btn" (click)="addDepartmentField()">
            <i class="material-icons-outlined">add</i>
        </button>
        <not [filter]="byDepartmentFilter" (filterChanged)="onFilterChanged($event)"></not>
        <button class="apply-btn" type="button" (click)="apply()">{{ 'filter.apply' | translate }}</button>
    </div>
</div>
